// extracted by mini-css-extract-plugin
export var carrierIcon = "_vz-0";
export var carrierLogo = "_vz-1";
export var detailsSection = "_vz-2";